module.exports = __webpack_public_path__ + "img/dawn.000785b8.png";